import script from "./CO2EmissionsLogo.vue?vue&type=script&setup=true&lang=ts"
export * from "./CO2EmissionsLogo.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__